import { render, staticRenderFns } from "./BancoMount.vue?vue&type=template&id=6384353a"
import script from "./BancoMount.vue?vue&type=script&lang=ts"
export * from "./BancoMount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6384353a')) {
      api.createRecord('6384353a', component.options)
    } else {
      api.reload('6384353a', component.options)
    }
    module.hot.accept("./BancoMount.vue?vue&type=template&id=6384353a", function () {
      api.rerender('6384353a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/BancoMount.vue"
export default component.exports